// extracted by mini-css-extract-plugin
module.exports = {"plTimelineWrap":"qqpPH","year":"m0apa","plTimeline":"HQifT","cardWrap":"kWJBN"};